import { DocumentoAllegato } from './documento-allegato';
import { StatoEntita } from './tipologiche/stato-entita';

export class ProvaScritta {

  id: string;
  descrizione: string;
  valore: string;
  scadenza: number;
  note: string;
  tipoProvaScritta: StatoEntita;
  documenti: DocumentoAllegato[];
}
